import React from "react";
import CookieConsent from "react-cookie-consent";
import Link from "next/link";
import "./cookiePolicy.scss";

const CookiePolicy = ({ t }: any) => {
  const consentLink = "/policies/cookie-policy";
  const consentLabel = t["Cookies Policy"];

  return (
    <CookieConsent
      location="bottom"
      buttonText={t["Accept"]}
      acceptOnScrollPercentage={10}
      cookieName="cookiePolicy"
      acceptOnScroll={true}
      containerClasses="cookieConsent"
      buttonStyle={{ background: "#576194", color: "white", fontSize: "16px" }}
      buttonId={"cookies-accepted"}
      expires={150}>
      <span className="cookieConsent__copy">
        {
          t[
            "This website uses its own or third-party cookies to improve your experience and our services, by analyzing your navigation of our website. By clicking Accept or continue browsing, we consider you to have accepted said cookies. To get more info or how to change your privacy settings, see our "
          ]
        }
      </span>
      <Link
        className="cookieConsent__link"
        href={consentLink}>
        {consentLabel}
      </Link>
    </CookieConsent>
  );
};

export default CookiePolicy;
